module.exports = __webpack_public_path__ + "assets/barbajs.7369d8f2.svg";